/* eslint-disable import/no-mutable-exports */
let USER_ROLES = [];

export function loadUserRoles(locales) {
  USER_ROLES = [
    { value: 'admin', label: locales.admin.admin },
    { value: 'lecturer', label: locales.admin.educator },
    { value: 'student', label: locales.admin.student },
    { value: 'super_admin', label: locales.admin.superAdmin },
  ];
}

export { USER_ROLES };
